<template>
  <div class="kye-preview-video">
    <video v-if="['mp4', 'mov'].includes(fileItem.extendName)" :src="fileItem.url" controls></video>
    <audio v-else controls :src="fileItem.url"></audio>
  </div>
</template>

<script>
export default {
  props: {
    fileItem: Object
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.kye-preview-video {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  video {
    width: 400px;
    height: 400px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-preview/component/file-video.vue